import { css, styled } from '@components-shared/src/stitches';
import { Indicator } from '@components/main-components/indicator';

export const MenuIcon = styled('div', {
  height: 20,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  paddingX: 0,
});

export const NavOpen = styled('div', {
  position: 'absolute',
  zIndex: '$search',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  backgroundColor: 'white',
});

export const SubContainer = styled('div', {
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  height: 40,
  width: '100%',
  '@tablet': {
    paddingX: 0,
  },
  variants: {
    variant: {
      right: {
        width: 'fit-content',
        marginLeft: 12,
      },
      mobile: {
        flexDirection: 'column',
        alignItems: 'unset',
        height: '100%',
      },
    },
    align: {
      end: {
        justifyContent: 'flex-end',
        gap: 16,
      },
    },
  },

  compoundVariants: [
    {
      variant: 'right',
      align: 'end',
      css: {
        marginLeft: 0,
      },
    },
  ],
});

export const navLinkStyle = css({
  cursor: 'pointer',
  color: '$neutral900',
  fontFamily: '$base',
  lineHeight: '120%',
  fontSize: 16,
  '&:hover': {
    color: '$neutral400',
  },
  variants: {
    variant: {
      desktop: {
        color: '$black',
        base: 'M',
        paddingY: 9,
        paddingLeft: 16,
        fontWeight: 400,
        position: 'relative',
        '&:hover': {
          backgroundColor: '$neutral100',
          color: 'unset',
        },
        '&:focus': {
          borderColor: '$neutral800',
          borderWidth: 2,
          // subtract the border width from the padding so we don't have any shifts
          paddingY: 8 - 2,
          paddingLeft: 16 - 2,
        },
      },

      mobile: {
        display: 'flex',
        alignItems: 'center',
        title: 'M',
        fontWeight: 500,
        transition: '0.3s all ease-in-out',
        '&:hover': {
          background: 'unset',
          color: 'unset',
        },
      },
    },
  },
});

export const NavLink = styled('div', navLinkStyle);

export const iconVariants = {
  variants: {
    fill: {
      neutral800: {
        [`& path`]: {
          fill: '$neutral800',
        },
      },
      white: {
        [`& path`]: {
          fill: '#fff',
        },
        '@tabletLandscape': {
          [`& path`]: {
            fill: '$neutral800',
          },
        },
      },
    },
    stroke: {
      black: {
        [`& path`]: {
          stroke: 'black',
        },
      },
      white: {
        color: 'white',
        [`& path`]: {
          stroke: '#fff',
        },
        '@tabletLandscape': {
          [`& path`]: {
            stroke: 'black',
          },
        },
      },
    },
  },
};

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  justifyContent: 'space-between',
});

export const MobileIcons = styled('div', {
  display: 'flex',
  columnGap: 20,
  alignItems: 'center',
});

export const IconContainer = styled('div', {
  ...iconVariants,
});

export const LinkIndicator = styled(Indicator, {
  variants: {
    variant: {
      desktop: {
        right: '10px',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      },
      mobile: {
        position: 'relative',
        top: '-5px',
      },
    },
  },
});

export const NewNavLink = styled('div', {
  display: 'flex',
  alignItems: 'center',
  title: 'M',
  color: '$base800',
  fontWeight: 500,
  height: 32,

  '@tablet': {
    height: 'unset',
    color: '$black',
    base: 'M',
    paddingY: 9,
    paddingLeft: 16,
    fontWeight: 400,
    position: 'relative',
    '&:hover': {
      backgroundColor: '$neutral100',
      color: 'unset',
    },
    '&:focus': {
      borderColor: '$base800',
      borderWidth: 2,
      // subtract the border width from the padding so we don't have any shifts
      paddingY: 8 - 2,
      paddingLeft: 16 - 2,
    },
  },

  variants: {
    size: {
      L: {
        title: 'XL',
        color: '$base800',
      },
    },
  },
});
